export default function ConsentNotice() {
  return (
    <div className="p-5 bg-gray-50 rounded-lg border border-gray-200 max-w-lg mx-auto">
      <h4 className="text-base font-bold font-heading text-gray-800 mb-3">
        Recording Notice &amp; Consent
      </h4>
      <p className="text-base text-gray-700 leading-[20px] mb-3">
        We record and transcribe our calls for quality assurance, training, and
        project preparation.
      </p>
      <ul className="text-base text-gray-700 leading-[20px] list-disc list-inside space-y-1">
        <li>
          By clicking the blue &ldquo;Join &amp; Consent&rdquo; button, you
          agree to this recording.
        </li>
        <li>If you do not consent, please do not join the call.</li>
      </ul>
    </div>
  );
}
